<template>
  <div class="korisnik">
    <!-- navbar -->
    <Navbar></Navbar>

    <div class="container">

      <PanelPokreni v-if="appState == 'round-in-progress'"/>

      <!-- povijst bodova -->
      <div class="povijest">
        <PovijestBodova hideSelector></PovijestBodova>
      </div>

      <!-- lista rezultata -->
      <RezultatiKolo></RezultatiKolo>

    </div>

  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import PovijestBodova from '../components/PovijestBodova.vue'
import RezultatiKolo from '../components/RezultatiKolo.vue'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'korisnik',
    data: function () {
        return {

        }
    },
    components: {
        Navbar,
        PovijestBodova,
        RezultatiKolo,
        PanelPokreni
    },
    computed: {
        appState () {
            return this.$store.state.appState
        }
    }
}
</script>

<style lang="scss" scoped>
  .korisnik {
    padding: 22px 0 40px 0;

    .poveznice {
      margin-bottom: 36px;
    }
    .povijest {
      margin-bottom: 60px;
    }
    .panel-pokreni {
      margin-bottom: 90px;
    }
  }
</style>
